import { render } from "./SolanaTokenInfo.vue?vue&type=template&id=64b3a47c&scoped=true"
import script from "./SolanaTokenInfo.vue?vue&type=script&lang=js"
export * from "./SolanaTokenInfo.vue?vue&type=script&lang=js"

import "./SolanaTokenInfo.vue?vue&type=style&index=0&id=64b3a47c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b3a47c"]])

export default __exports__